export default __webpack_public_path__ + "static/media/left-arrow.224167d1.svg";